import { Link } from 'react-router-dom';

const blogPosts = [
  {
    slug: '/blog/best-sugargoo-spreadsheet-2026-guide',
    title: 'Best Sugargoo Spreadsheet 2026: Complete Beginner Guide',
    excerpt: 'Everything you need to know about using sugargoo spreadsheets effectively. Learn how to find the best deals, navigate categories, and maximize your shopping experience.',
    date: 'June 15, 2026',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=Modern%20open%20laptop%20on%20clean%20minimalist%20white%20desk%20displaying%20colorful%20organized%20spreadsheet%20interface%20with%20product%20listings%2C%20bright%20sunlit%20home%20office%20with%20trailing%20green%20plants%20and%20ceramic%20coffee%20mug%2C%20warm%20natural%20daylight%20creating%20soft%20shadows%2C%20productive%20creative%20workspace%20with%20notebooks%20and%20highlighters&width=600&height=400&seq=blog-v4-card-01-guide&orientation=landscape',
  },
  {
    slug: '/blog/how-to-use-sugargoo-spreadsheet',
    title: 'How to Use a Sugargoo Spreadsheet Effectively',
    excerpt: 'Master the art of spreadsheet navigation with our step-by-step tutorial. From filtering to price comparison, become a power user in minutes.',
    date: 'June 12, 2026',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20elegantly%20typing%20on%20sleek%20silver%20laptop%20with%20vibrant%20spreadsheet%20dashboard%20visible%20on%20bright%20screen%2C%20cozy%20modern%20cafe%20setting%20with%20exposed%20brick%20wall%20and%20industrial%20pendant%20lights%2C%20warm%20ambient%20glow%2C%20artisanal%20latte%20with%20latte%20art%20nearby%20on%20marble%20table&width=600&height=400&seq=blog-v4-card-02-howto&orientation=landscape',
  },
  {
    slug: '/blog/top-50-sneaker-finds-sugargoo-spreadsheet',
    title: 'Top 50 Sneaker Finds on Sugargoo Spreadsheet',
    excerpt: 'Discover the hottest sneaker deals curated from the sugargoo spreadsheet. Nike, Adidas, Jordan and more — all verified and updated daily.',
    date: 'June 10, 2026',
    readTime: '15 min read',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20sneaker%20collection%20creatively%20arranged%20on%20urban%20concrete%20staircase%20with%20vibrant%20graffiti%20mural%20backdrop%2C%20various%20designer%20styles%20from%20chunky%20dad%20shoes%20to%20sleek%20runners%2C%20bright%20afternoon%20sunlight%20casting%20dynamic%20shadows%2C%20street%20culture%20photography%20with%20authentic%20city%20atmosphere&width=600&height=400&seq=blog-v4-card-03-sneakers&orientation=landscape',
  },
  {
    slug: '/blog/best-clothing-finds-sugargoo-spreadsheet',
    title: 'Best Clothing Finds from Sugargoo Spreadsheet',
    excerpt: 'Comprehensive guide to the best clothing finds including hoodies, t-shirts, jackets, and pants. Curated by the community for quality and style.',
    date: 'June 8, 2026',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=Trendy%20fashion%20boutique%20clothing%20rack%20with%20colorful%20curated%20garments%20in%20soft%20pastels%20and%20earth%20tones%2C%20bright%20airy%20retail%20space%20with%20warm%20track%20lighting%20and%20polished%20concrete%20floors%2C%20organized%20merchandising%20display%2C%20lifestyle%20fashion%20photography%20with%20plants%20and%20full-length%20mirror%20in%20background&width=600&height=400&seq=blog-v4-card-04-clothing&orientation=landscape',
  },
  {
    slug: '/blog/best-budget-finds-sugargoo-spreadsheet',
    title: 'Best Budget Finds Under $20 on Sugargoo Spreadsheet',
    excerpt: 'Discover the best cheap spreadsheet finds under $20. Accessories, tees, and items that offer incredible value — perfect for beginners.',
    date: 'June 5, 2026',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20assortment%20of%20affordable%20fashion%20accessories%20including%20colorful%20beaded%20bracelets%20enamel%20pins%20and%20printed%20socks%20creatively%20arranged%20in%20circular%20flat%20lay%20on%20bright%20turquoise%20surface%2C%20playful%20budget%20shopping%20concept%2C%20cheerful%20overhead%20photography%20with%20confetti%20and%20paper%20stars%20scattered%20around&width=600&height=400&seq=blog-v4-card-05-budget&orientation=landscape',
  },
  {
    slug: '/blog/sugargoo-spreadsheet-vs-pandabuy',
    title: 'Sugargoo Spreadsheet vs Pandabuy: Complete Comparison',
    excerpt: 'Comprehensive comparison of the two platforms. See which offers the best product variety, pricing, and user experience for spreadsheet shoppers.',
    date: 'June 3, 2026',
    readTime: '13 min read',
    image: 'https://readdy.ai/api/search-image?query=Two%20modern%20tablets%20placed%20side%20by%20side%20on%20dark%20matte%20surface%20showing%20different%20shopping%20platform%20interfaces%2C%20dramatic%20split%20lighting%20with%20warm%20amber%20on%20left%20and%20cool%20white%20on%20right%2C%20tech%20comparison%20concept%20photography%2C%20clean%20minimalist%20composition%20with%20stark%20contrast%20and%20reflection&width=600&height=400&seq=blog-v4-card-06-vs&orientation=landscape',
  },
  {
    slug: '/blog/how-sugargoo-works-2026',
    title: 'How Sugargoo Works in 2026: Complete Platform Guide',
    excerpt: 'Step-by-step guide covering ordering, shipping, QC photos, and tips for the best shopping experience using the Sugargoo platform with spreadsheets.',
    date: 'June 1, 2026',
    readTime: '14 min read',
    image: 'https://readdy.ai/api/search-image?query=Organized%20modern%20fulfillment%20center%20interior%20with%20neatly%20stacked%20branded%20parcels%20and%20packages%20on%20industrial%20metal%20shelving%20under%20bright%20clean%20LED%20lighting%2C%20efficient%20logistics%20operations%20environment%2C%20professional%20commercial%20warehouse%20photography%2C%20clean%20organized%20atmosphere%20with%20workers%20in%20background%20handling%20shipments&width=600&height=400&seq=blog-v4-card-07-howworks&orientation=landscape',
  },
  {
    slug: '/blog/best-hoodie-spreadsheet-collection',
    title: 'Best Hoodie Sugargoo Spreadsheet Collection 2026',
    excerpt: 'Explore the ultimate hoodie collection featuring oversized fits, graphic designs, and premium fleece options at unbeatable prices — all community curated.',
    date: 'May 28, 2026',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20collection%20of%20premium%20heavyweight%20hoodies%20in%20warm%20earthy%20tones%20of%20ochre%20rust%20moss%20and%20cream%20hanging%20on%20minimalist%20wooden%20rack%2C%20sunlit%20Scandinavian%20interior%20with%20white%20walls%20and%20indoor%20plants%2C%20soft%20natural%20window%20light%20creating%20gentle%20highlights%20on%20thick%20cotton%20fleece%20texture%2C%20cozy%20lifestyle%20fashion%20photography&width=600&height=400&seq=blog-v4-card-08-hoodie&orientation=landscape',
  },
  {
    slug: '/blog/yupoo-sugargoo-complete-workflow',
    title: 'Yupoo and Sugargoo Spreadsheet: Complete Workflow Guide',
    excerpt: 'Master the Yupoo and spreadsheet workflow. Learn to find galleries, verify sellers, and create an efficient shopping pipeline that saves time and money.',
    date: 'May 25, 2026',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=Ultrawide%20curved%20monitor%20on%20modern%20standing%20desk%20displaying%20organized%20product%20image%20gallery%20grid%20with%20thumbnail%20previews%2C%20bright%20contemporary%20home%20office%20with%20natural%20daylight%20and%20green%20plants%2C%20tech%20savvy%20creative%20workspace%2C%20clean%20minimal%20desk%20setup%20with%20wireless%20keyboard%20and%20succulents%20in%20ceramic%20pots&width=600&height=400&seq=blog-v4-card-09-yupoo&orientation=landscape',
  },
];

export default function BlogGrid() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-12">
          <span className="text-[11px] text-foreground-500 uppercase tracking-widest font-semibold">Latest Guides</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3">
            Sugargoo Spreadsheet Articles
          </h2>
          <p className="mt-3 text-[14px] text-foreground-600 max-w-xl leading-relaxed">
            Expert guides and tutorials to help you make the most of your sugargoo spreadsheet experience. New articles added weekly.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {blogPosts.map((post, idx) => (
            <Link
              key={idx}
              to={post.slug}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  title={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-[12px] text-foreground-400 mb-2 font-medium">
                  <span>{post.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{post.readTime}</span>
                </div>
                <h3 className="font-heading text-[15px] font-bold text-foreground-950 group-hover:text-primary-700 transition-colors leading-snug">
                  {post.title}
                </h3>
                <p className="mt-2 text-[13px] text-foreground-600 leading-relaxed line-clamp-2">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-[13px] font-semibold text-primary-600">
                  Read More <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3 border-2 border-foreground-900 text-foreground-900 text-[14px] font-bold rounded-full hover:bg-foreground-900 hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            Browse Full Spreadsheet <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}